/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_gov_003: Question = {
  id: 'gov-003-plan-strategique-local',
  oldId: '3',
  title: 'Publication d\'un plan stratégique local',
  number: '1.3',
  type: QuestionType.ACTIVITY,
  idEM: 1,
  frequency: 1,
  description: ['Un plan stratégique local pour la préservation de la diversité biologique a été publié. Il peut s\'agir d\'une politique, d\'un plan stratégique ou d\'un plan d\'action qui fixe des objectifs tangibles. Si applicable, indiquer la date d\'échéance.'],
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoringFct: (data: string[]) => parseFloat(data[0]),
      scoreCalculatedLater: false,
      optional: false,
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

const question_gov_003__v3: Question = {
  ...question_gov_003,
  frequency: 4,
};

export const question_gov_003_v2: Question = question_gov_003;
export const question_gov_003_v3: Question = question_gov_003__v3;
